import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import KeyIcon from '@mui/icons-material/Key';
import PasswordIcon from '@mui/icons-material/Password';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import _map from 'lodash/map';
import { ReactNode, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import CardCryptoPayment from './CardCryptoPayment';
import HeaderStep, { ButtonData } from './HeaderStep';

interface Steps {
    step: number;
    title: string;
    description: string;
    icon: ReactNode;
}
const steps: Steps[] = [
    {
        step: 1,
        title: '2FA',
        description: 'step-2FA-description',
        icon: <GppMaybeIcon sx={{ fontSize: '1rem' }} color="inherit" />
    },
    {
        step: 2,
        title: 'password',
        description: 'step-password-description',
        icon: <PasswordIcon fontSize="small" color="inherit" />
    },
    {
        step: 3,
        title: 'disable-auto-sign',
        description: 'step-disable-auto-sign-description',
        icon: <KeyIcon fontSize="small" color="inherit" />
    }
];

const StepBoostWalletSecurity = () => {
    const theme = useTheme();
    const handleReadHow = () => {
        window.open('https://xaigate.gitbook.io/api-docs', '_blank');
    };
    const buttons = useMemo<ButtonData[]>(
        () => [
            // { id: 1, title: 'read-how', onClick: handleReadHow }
        ],
        [handleReadHow]
    );

    return (
        <Grid container flexDirection="column" gap={1}>
            <Grid item xs={12}>
                <HeaderStep title="step-boost-wallet-security" buttons={buttons} />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body1">
                    <FormattedMessage id="step-boost-wallet-description" />
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }} gap={2}>
                    {_map(steps, (step) => (
                        <Grid item key={step.step} xs={12} md={6}>
                            <CardCryptoPayment
                                {...step}
                                flexDirection="column"
                                gap={1}
                                sizeIcon={24}
                                childrenIcon={
                                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ color: theme.palette.text.hint }}>
                                        {step.icon}
                                    </Box>
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default StepBoostWalletSecurity;
